import { Navigate, useLocation } from "react-router-dom";

const AdminProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("hobAdminToken");

  // No token at all → redirect to login
  if (!token) {
    return <Navigate to="/admin" replace state={{ from: location.pathname }} />;
  }

  // Token exists — validate it (check expiry from JWT payload)
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp && Date.now() / 1000 > payload.exp) {
      localStorage.removeItem("hobAdminToken");
      return (
        <Navigate to="/admin" replace state={{ from: location.pathname }} />
      );
    }
  } catch {
    // Malformed token
    localStorage.removeItem("hobAdminToken");
    return <Navigate to="/admin" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default AdminProtectedRoute;
